import { GET,  } from "../../helper/xbi4RestFunctions";
export const getOrgUserGoals = async (org_id: any, orgUserId: any) => {
  const path = `/orgs/${org_id}/users/${orgUserId}/goals`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
